import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons/lib/icons";
import { Row, Steps } from "antd";
import React from "react";
const { Step } = Steps;

export const ReviewProduct = ({ controlStatusGeneral, productFlow = "simple" }) => {
  const isWebOnlyFlow = productFlow === "variable-parent-web";
  const stepItems = isWebOnlyFlow
    ? [
        {
          title: "Preparar producto web",
          description: controlStatusGeneral.messagestep1,
        },
        {
          title: "Crear producto en Página Web",
          description: controlStatusGeneral.messagestep2,
        },
      ]
    : [
        {
          title: "Obtener token",
          description: controlStatusGeneral.messagestep1,
        },
        {
          title: "Crear producto ARI",
          description: controlStatusGeneral.messagestep2,
        },
        {
          title: "Crear Producto",
          description: controlStatusGeneral.messagestep3,
        },
      ];

  const currentStep = Number(controlStatusGeneral.step || 1);
  const currentIndex = Math.max(
    0,
    Math.min(currentStep - 1, stepItems.length - 1),
  );

  const getStepIcon = (index) => {
    const stepNumber = index + 1;
    const isCurrent = currentStep === stepNumber;
    const isCompleted =
      currentStep > stepNumber ||
      (controlStatusGeneral.status === "success" &&
        currentStep >= stepItems.length);
    const isError =
      isCurrent && controlStatusGeneral.status === "error";

    if (isCurrent && controlStatusGeneral.status === "loading") {
      return <LoadingOutlined />;
    }

    if (isCompleted) {
      return <CheckCircleOutlined style={{ color: "green" }} />;
    }

    if (isError) {
      return <CloseCircleOutlined style={{ color: "red" }} />;
    }

    return null;
  };

  return (
    <>
      <Row justify="center" style={{ marginTop: "10px" }}>
        <Steps direction="vertical" current={currentIndex}>
          {stepItems.map((item, index) => (
            <Step
              key={item.title}
              icon={getStepIcon(index)}
              title={item.title}
              description={item.description}
            />
          ))}
        </Steps>
      </Row>
    </>
  );
};
